import { getContract, PublicClient, WalletClient } from 'viem';

import { getPoolOwnershipAddress } from 'modules/api/methods/getPoolOwnershipAddress';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

import poolOwnershipAbi from '../abi/PoolOwnership';

async function _getPoolOwnershipContract(clients: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
}) {
  const { publicClient, walletClient } = clients;

  const poolOwnershipAddress = await getPoolOwnershipAddress(publicClient);

  return getContract({
    client: walletClient || publicClient,
    abi: poolOwnershipAbi,
    address: poolOwnershipAddress,
  });
}

export const getPoolOwnershipContract = memoizePromise(
  _getPoolOwnershipContract,
  clients => {
    return `${clients.publicClient.chain?.id || clients.walletClient?.chain?.id || 'unknown'}`;
  },
);
